export default __webpack_public_path__ + "static/media/Ellipse1.a757210a.png";